var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeftLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 421,
    viewBox: "0 0 363 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 324.696,
    y: -103.398,
    width: 50,
    height: 641.612,
    rx: 20,
    transform: "rotate(40 324.696 -103.398)",
    fill: "#344D50",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 304.696,
    y: -113.398,
    width: 50,
    height: 641.612,
    rx: 20,
    transform: "rotate(40 304.696 -113.398)",
    fill: "#344D50",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftLines);
export default __webpack_public_path__ + "static/media/top-left-lines.e14d6c1775cf883c82fc4d95997717e7.svg";
export { ForwardRef as ReactComponent };